module.exports = __webpack_public_path__ + "img/WP2023-Online-RegFees.572bf93d.png";